import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/auth/pages/lnx-auth-init/lnx-auth-init.page').then(m => m.LnxAuthInitPage),
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.routes').then(m => m.adminRoutes),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin'] }
  },
  {
    path: 'residente',
    loadChildren: () =>
      import('./features/residente/residente.routes').then(m => m.residenteRoutes),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['residente'] }
  },
  {
    path: 'guardia',
    loadChildren: () =>
      import('./features/guardia/guardia.routes').then(m => m.guardiaRoutes),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['guardia'] }
  },
  {
    path: 'superadmin',
    loadChildren: () =>
      import('./features/superadmin/superadmin.routes').then(m => m.superadminRoutes),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['superadmin'] }
  },
  { path: '**', redirectTo: 'auth/login' }
];
